import React from 'react';
import Reveal from './Reveal';
import { Heading, Link } from '@chakra-ui/layout';

const UcommerceContent = () => {
  return (
    <Reveal>
      <Heading as="p" size="md" lineHeight={1.4} mr={6} ml={6} mt={8}>
        Description: <br />
        uCommerce is a Full-Stack C2C e-Commerce Web Application that allows
        student of Universitas Klabat sells the products of their small business
        online. I made this project to fulfill the requirement of graduation
        from my university. <br />
        <br />
        Sadly, I can't afford to continue to host this Web Application online.
        So I will provide my research project journal and a couple of screenshot
        of this App. <br />
        <br />
        <Link
          color="orange.500"
          href="https://drive.google.com/file/d/1xBDlBjI2PyTIi8eXSRp2Q4emtEDb4K7D/view?usp=sharing"
          isExternal
        >
          Link to the Journal
        </Link>
        <br />
        <br />
        Technology Used:{' '}
        <Link color="orange.500" href="https://laravel.com/" isExternal>
          Laravel
        </Link>
        ,{' '}
        <Link color="orange.500" href="https://php.net/" isExternal>
          PHP
        </Link>
        ,{' '}
        <Link
          color="orange.500"
          href="https://www.w3schools.com/html/"
          isExternal
        >
          HTML
        </Link>
        ,{' '}
        <Link
          color="orange.500"
          href="https://www.w3schools.com/css/"
          isExternal
        >
          CSS
        </Link>
        ,{' '}
        <Link color="orange.500" href="https://getbootstrap.com/" isExternal>
          Bootstrap
        </Link>
        ,{' '}
        <Link color="orange.500" href="https://voyager.devdojo.com/" isExternal>
          Voyager Admin Panel
        </Link>{' '}
        &{' '}
        <Link color="orange.500" href="https://www.mysql.com/" isExternal>
          MySQL
        </Link>{' '}
        for the database.
        <br />
        Credits to{' '}
        <Link
          color="orange.500"
          href="https://www.youtube.com/channel/UCjpCwTGrMRuTi4FcrCYbkSQ"
          isExternal
        >
          WebDevMatics
        </Link>{' '}
        on YouTube for guiding me building this project.
      </Heading>
    </Reveal>
  );
};

export default UcommerceContent;
